module.exports = __webpack_public_path__ + "img/digital.c60775b1.svg";